exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.regulationContainer[data-v-648fb19c]{\n\tfont-size: 18px;\n}\n.page__title[data-v-648fb19c]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-648fb19c] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-648fb19c] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-648fb19c]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-648fb19c]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-648fb19c] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-648fb19c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/index.vue
// module id = dPwX
// module chunks = 1